import { render, staticRenderFns } from "./userSb-scenario-comparison.vue?vue&type=template&id=4a9f4981"
import script from "./userSb-scenario-comparison.vue?vue&type=script&lang=ts"
export * from "./userSb-scenario-comparison.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports